/* JohnnyHome – small behaviours for jh- sections. No dependencies. */
(() => {
  const init = (root = document) => {
    // Sticky header shadow
    const header = root.querySelector('.jh-header, [data-jh-header]');
    if (header && !header.dataset.jhInit) {
      header.dataset.jhInit = '1';
      // Horizon scrolls inside .page-wrapper on desktop, the window on mobile
      const wrapper = document.querySelector('.page-wrapper');
      const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8 || (wrapper?.scrollTop || 0) > 8);
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
      wrapper?.addEventListener('scroll', onScroll, { passive: true });
    }

    // Mega menu: hover on desktop, click/keyboard everywhere
    root.querySelectorAll('.jh-nav__item[data-has-mega]').forEach((item) => {
      if (item.dataset.jhInit) return;
      item.dataset.jhInit = '1';
      const trigger = item.querySelector('.jh-nav__link');
      let t;
      const open = () => { clearTimeout(t); closeAll(item); item.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); };
      const close = () => { t = setTimeout(() => { item.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); }, 120); };
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', close);
      trigger.addEventListener('click', (e) => {
        if (!item.classList.contains('is-open')) { e.preventDefault(); open(); }
      });
      item.addEventListener('keydown', (e) => { if (e.key === 'Escape') { item.classList.remove('is-open'); trigger.focus(); } });
      item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) close(); });
    });
    function closeAll(except) {
      document.querySelectorAll('.jh-nav__item.is-open').forEach((i) => i !== except && i.classList.remove('is-open'));
    }

    // Drawer + search toggles
    root.querySelectorAll('[data-jh-toggle]').forEach((btn) => {
      if (btn.dataset.jhInit) return;
      btn.dataset.jhInit = '1';
      btn.addEventListener('click', (e) => {
        const target = document.getElementById(btn.dataset.jhToggle);
        if (!target) return;
        const isOpen = target.classList.toggle('is-open');
        document.querySelectorAll(`[data-jh-toggle="${btn.dataset.jhToggle}"]`).forEach((b) => b.setAttribute('aria-expanded', String(isOpen)));
        if (target.classList.contains('jh-drawer') || target.hasAttribute('data-jh-lock')) document.documentElement.style.overflow = isOpen ? 'hidden' : '';
        // Move focus only for keyboard users (or into a search field); a tap would leave a focus ring on the first link
        const first = isOpen && target.querySelector('input, a, button');
        if (first && (e.detail === 0 || first.matches('input'))) first.focus();
      });
    });

    // Horizontal carousels: <button data-jh-scroll="id" data-dir="1">
    root.querySelectorAll('[data-jh-scroll]').forEach((btn) => {
      if (btn.dataset.jhInit) return;
      btn.dataset.jhInit = '1';
      btn.addEventListener('click', () => {
        const track = document.getElementById(btn.dataset.jhScroll);
        if (!track) return;
        const card = track.firstElementChild;
        const step = card ? card.getBoundingClientRect().width + 20 : track.clientWidth * 0.8;
        track.scrollBy({ left: step * Number(btn.dataset.dir || 1), behavior: 'smooth' });
      });
    });

    // Announcement rotator
    root.querySelectorAll('.jh-topbar__msgs').forEach((box) => {
      if (box.dataset.jhInit) return;
      box.dataset.jhInit = '1';
      const msgs = [...box.querySelectorAll('.jh-topbar__msg')];
      if (msgs.length < 2) return;
      let i = 0;
      setInterval(() => {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, Number(box.dataset.speed || 4500));
    });

    // Reveal on scroll
    const items = root.querySelectorAll('.jh-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { items.forEach((el) => el.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach((el, idx) => { el.style.transitionDelay = `${(el.dataset.delay || 0)}ms`; io.observe(el); });
  };

  // Subcategory pill rows: arrows + mouse-wheel scrolling on desktop
  const initSubs = () => {
    document.querySelectorAll('[data-jhl-subs]').forEach((wrap) => {
      const row = wrap.querySelector('.jhl-subs');
      if (!row) return;
      const prev = wrap.querySelector('[data-dir="-1"]'), next = wrap.querySelector('[data-dir="1"]');
      const sync = () => {
        const max = row.scrollWidth - row.clientWidth;
        if (prev) prev.hidden = row.scrollLeft <= 2;
        if (next) next.hidden = row.scrollLeft >= max - 2;
        wrap.classList.toggle('has-more', max > 2);
      };
      if (!wrap.dataset.init) {
        wrap.dataset.init = '1';
        [prev, next].forEach((b) => b && b.addEventListener('click', () => row.scrollBy({ left: Number(b.dataset.dir) * row.clientWidth * 0.7, behavior: 'smooth' })));
        row.addEventListener('scroll', sync, { passive: true });
        row.addEventListener('wheel', (e) => {
          if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
          const max = row.scrollWidth - row.clientWidth; if (max <= 0) return;
          const to = row.scrollLeft + e.deltaY;
          if ((to <= 0 && row.scrollLeft <= 0) || (to >= max && row.scrollLeft >= max)) return;
          e.preventDefault(); row.scrollLeft = to;
        }, { passive: false });
        if ('ResizeObserver' in window) new ResizeObserver(sync).observe(row);
      }
      sync();
    });
  };
  initSubs();

  // Product carousels ([data-jhcar]): arrows scroll one card, disabled at the ends
  const initCar = () => document.querySelectorAll('[data-jhcar]').forEach((root) => {
    const track = root.querySelector('[data-jhcar-track]');
    if (!track || root.dataset.carInit) return;
    root.dataset.carInit = '1';
    const btns = [...root.querySelectorAll('[data-jhcar-btn]')];
    const step = () => { const c = track.firstElementChild; return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 14) : track.clientWidth; };
    const sync = () => {
      const max = track.scrollWidth - track.clientWidth;
      btns.forEach((b) => { b.disabled = Number(b.dataset.jhcarBtn) < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= max - 2; });
      root.classList.toggle('jhcar-static', max <= 2);
    };
    btns.forEach((b) => b.addEventListener('click', () => track.scrollBy({ left: Number(b.dataset.jhcarBtn) * step(), behavior: 'smooth' })));
    track.addEventListener('scroll', sync, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(sync).observe(track);
    window.addEventListener('load', sync);
    sync();
  });
  initCar();

  // Tier tooltips (.jhtt): tap to open on touch screens (hover opens them on desktop)
  const ttClose = (except) => document.querySelectorAll('.jhtt.is-open').forEach((t) => t !== except && t.classList.remove('is-open'));
  const ttPlace = (tt) => {
    const pop = tt.querySelector('.jhtt__pop'); if (!pop) return;
    pop.style.left = ''; pop.style.right = ''; pop.style.transform = '';
    const r = pop.getBoundingClientRect(), pad = 12, vw = document.documentElement.clientWidth;
    let dx = 0;
    if (r.right > vw - pad) dx = vw - pad - r.right;
    if (r.left + dx < pad) dx = pad - r.left;
    if (dx) pop.style.transform = `translateX(${Math.round(dx)}px)`;
  };
  document.addEventListener('click', (e) => {
    const tt = e.target.closest('.jhtt');
    if (!tt) { ttClose(); return; }
    if (e.target.closest('.jhtt__pop')) return;
    if (!matchMedia('(hover: none)').matches) return;
    if (e.target.closest('a')) return;
    e.preventDefault();
    const open = !tt.classList.contains('is-open');
    ttClose(tt); tt.classList.toggle('is-open', open);
    if (open) requestAnimationFrame(() => ttPlace(tt));
  });
  window.addEventListener('jhl:subs', initSubs);
  window.addEventListener('load', initSubs);

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.jh-drawer.is-open, .jh-search.is-open, [data-jh-lock].is-open').forEach((el) => {
      el.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
